

export const actionTypes = {
  SET_APPOINTMENT_STAR_RATING: "SET_APPOINTMENT_STAR_RATING",
  SET_APPOINTMENT_STEP_ONE_FEEDBACK: "SET_APPOINTMENT_STEP_ONE_FEEDBACK",
  SET_APPOINTMENT_RATING_NULL: "SET_APPOINTMENT_RATING_NULL",
};

const setAppointmentsStarRating = (payload: any) => ({
  type: actionTypes.SET_APPOINTMENT_STAR_RATING,
  payload,
});

const setAppointmentStepOneFeedback = (payload: string | null) => ({
  type: actionTypes.SET_APPOINTMENT_STEP_ONE_FEEDBACK,
  payload,
});


const setAppointmentRatingNull = () => ({
  type: actionTypes.SET_APPOINTMENT_RATING_NULL,
});

export default {
  setAppointmentsStarRating,
  setAppointmentRatingNull,
  setAppointmentStepOneFeedback,
};
